import React, { useState, useEffect } from "react";
import { Spin, Button } from "antd";
import { Smartphone, Wifi, CreditCard, Gamepad2, History, Home as HomeIcon, User } from "lucide-react";
import PhoneTopup from "../components/Steps/PhoneTopup";
import DataPackage from "../components/Steps/DataPackage";
import CardPhone from "../components/Steps/CardPhone";
import GameCard from "../components/Steps/GameCard";
import HistoryStep from "../components/Steps/History";
import { fetchAdvImage } from "../services/topupService";
import { withRouter } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const TABS = [
  { key: "phone", icon: Smartphone, label: "Nạp tiền", type: 1 },
  { key: "data", icon: Wifi, label: "Nạp Data", type: 3 },
  { key: "game", icon: Gamepad2, label: "Nạp Game", type: 2 },
  { key: "card", icon: CreditCard, label: "Mua thẻ", type: 4 },
  { key: "history", icon: History, label: "Lịch sử" },
];

const Home = ({ token, route, history }) => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(route || "phone");
  const [advImagesInit, setAdvImagesInit] = useState([]);
  const [headerImage, setHeaderImage] = useState("https://images.unsplash.com/photo-1557683316-973673baf926?q=80&w=800&auto=format&fit=crop");

  useEffect(() => {
    const loadAdvImages = async () => {
      try {
        const res = await fetchAdvImage();
        setAdvImagesInit(res?.data?.data ?? []);
      } catch (error) {
        // fallback to default image
      }
    };
    loadAdvImages();
  }, []);

  // Sync activeTab when route prop changes
  useEffect(() => {
    if (route && route !== activeTab) {
      setActiveTab(route);
    }
  }, [route]);

  // Navigate when tab changes
  useEffect(() => {
    if (activeTab === "phone") {
      history.replace("/phone");
    } else if (activeTab === "data") {
      history.replace("/data");
    } else if (activeTab === "game") {
      history.replace("/game");
    } else if (activeTab === "card") {
      history.replace("/cardPhone");
    } else if (activeTab === "history") {
      history.replace("/history");
    }
  }, [activeTab, history]);

  const getImageUrl = (link) => {
    if (!link) return "";
    return link.startsWith("http") ? link : `${BASE_URL}${link}`;
  };

  useEffect(() => {
    const currentTab = TABS.find((t) => t.key === activeTab);
    const type = currentTab?.type;
    if (advImagesInit.length > 0 && type) {
      const matched = advImagesInit.find((x) => x.type === type);
      if (matched?.link) {
        setHeaderImage(getImageUrl(matched.link));
      } else {
        setHeaderImage("https://images.unsplash.com/photo-1557683316-973673baf926?q=80&w=800&auto=format&fit=crop");
      }
    }
  }, [activeTab, advImagesInit]);

  const renderStepComponent = (step) => {
    switch (step) {
      case "phone":
        return <PhoneTopup setLoading={setLoading} loading={loading} token={token} />;
      case "data":
        return <DataPackage setLoading={setLoading} loading={loading} token={token} />;
      case "card":
        return <CardPhone setLoading={setLoading} loading={loading} token={token} />;
      case "game":
        return <GameCard setLoading={setLoading} loading={loading} token={token} />;
      case "history":
        return <HistoryStep setLoading={setLoading} loading={loading} />;
      default:
        return <PhoneTopup setLoading={setLoading} loading={loading} token={token} />;
    }
  };

  return (
    <Spin tip="Đang tải dữ liệu..." size="large" spinning={loading}>
      <div className="min-h-screen bg-gray-50 flex justify-center">
        <div className="w-full bg-gray-50 min-h-screen relative shadow-2xl flex flex-col">

          {/* Header with Banner */}
          <div className="relative">
            <img
              src={headerImage}
              alt="banner"
              className="w-full h-48 object-cover rounded-b-3xl"
            />
          </div>

          {/* Tab Navigation - Overlapping header */}
          <div className="px-4 -mt-5 relative z-20">
            <div className="bg-white rounded-2xl p-1.5 flex items-center overflow-x-auto hide-scrollbar gap-1">
              {TABS.map((tab) => {
                const Icon = tab.icon;
                const isActive = activeTab === tab.key;
                return (
                  <Button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    type={isActive ? "primary" : "text"}
                    className="!min-w-[70px] !shrink-0 !flex !flex-col !items-center !justify-center !py-2.5 !px-1 !rounded-xl !h-auto !shadow-none"
                  >
                    <div className="mb-1"><Icon size={18} /></div>
                    <span className="text-sm !font-bold whitespace-nowrap">{tab.label}</span>
                  </Button>
                );
              })}
            </div>
          </div>

          {/* Main Content - scrollable */}
          <div className="flex-1 overflow-y-auto">
            <div className="px-4 py-5">
              {renderStepComponent(activeTab)}
            </div>
          </div>

        </div>
      </div>
    </Spin>
  );
};

export default withRouter(Home);